import PropTypes from 'prop-types';
import CurrencyFormatter from '@spotahome/marketplace-common/src/utils/CurrencyFormatter';
import HomeCard from '@spotahome/marketplace-common/src/components/Homecard';

import { getDateAsUTC } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

import { TRACKING_PAGE_TYPES } from '@spotahome/ecommerce-tracking/src/constants';

import './FavoritesHomecard.scss';

const FavoritesHomecard = ({
  homecard,
  onClick = () => {},
  onToggleFavorite = () => {},
  renderExtraContent = () => {}
}) => {
  const currentYear = getDateAsUTC(new Date()).getFullYear();

  const { currencyLabel, currencySymbol, currencyIsoCode } = homecard;

  const currency = new CurrencyFormatter(
    currencyLabel,
    currencySymbol,
    currencyIsoCode
  );

  const handleHomecardClick = () => {
    onClick();
  };

  const firstAvailableDate = getDateAsUTC(
    new Date(homecard.firstAvailableDate)
  );
  const firstAvailableYear = firstAvailableDate?.getFullYear();

  return (
    <div className={'favorites-home-card__wrapper'}>
      <HomeCard
        data={{
          ...homecard,
          isFavorite: true
        }}
        onToggleFavorite={onToggleFavorite}
        currency={currency}
        onClick={handleHomecardClick}
        showAvailableFromYear={firstAvailableYear !== currentYear}
        renderExtraContent={renderExtraContent}
        pageType={TRACKING_PAGE_TYPES.FAVORITES}
      />
    </div>
  );
};

FavoritesHomecard.propTypes = {
  homecard: PropTypes.shape({
    id: PropTypes.string,
    currencyLabel: PropTypes.string,
    currencySymbol: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    firstAvailableDate: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  onToggleFavorite: PropTypes.func,
  renderExtraContent: PropTypes.func
};

export default FavoritesHomecard;
